import * as Yup from "yup";

export const TurninFormValidation = Yup.object().shape({
  StudentPoint: Yup.number().required("Grade is required!").nullable(),
});
